import React, {useRef, useState} from 'react';
import { withStyles, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import TranslateList from './TranslateList';
import { hasPermission, createHistory } from '../../sc-utilities';
import { EditOutlined, DeleteOutline } from '@material-ui/icons';
import * as action from '../../np-core/Auth/store/authActions';
import { snackActions } from '../../sc-utilities/SnackBar';
import { Redirect } from 'react-router-dom';
import {download} from "../../sc-utilities/download.utils";
import config from "../../../config/config";

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    "@global": {
        "[class*='statusActive']": {
            color: theme.palette.success.dark
        },
        "[class*='statusInactive']": {
            color: theme.palette.error.dark
        },
        "[class*='button']": {
            textTransform: 'none',
            textDecoration: 'none'
        }
    },
    button: {
        textTransform: 'none',
        textDecoration: 'none'
    },
    statusActive: {
        color: theme.palette.success.dark
    },
    statusInactive: {
        color: theme.palette.error.dark
    }
});

const Translations = props => {
    const tableRef = useRef();
    const { classes, translations, permissions, columns, activeCustomer } = props;
    let visible = columns && columns['Translations'];
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, translationID: null, redirectPath: "" });
    const [deleteModalState, setDeleteModalState] = useState({
        open: false,
        translationID: null
    })

    let tableColumns = [
        {
            title: translations["key"] || 'Key', field: 'Key',
            hidden: visible ? visible['Key'] : false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Key ? rowData.Key : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: `${translations["default_languege"] || 'Default language'}(EN)`, field: 'Default',
            hidden: visible ? visible['Key'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Translations ? JSON.parse(rowData.Translations).en ? JSON.parse(rowData.Translations).en : translations['short_not_assigned'] || 'n/a' : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        }
    ];
    const handleDelete = async (event, rowData) => {
        if (!rowData) {
            setDeleteModalState({ open: false, translationID: null });
            return;
        }
        setDeleteModalState({ open: true, translationID: rowData.TranslationID });
    };

    const goToEditTranslations = (id) => {
        createHistory();
        setRedirectOptions({ ...redirectOptions, redirect: true, TranslationsID: null, redirectPath: `/admin/translate/edit?translationID=${id.TranslationID}` });
    };

    const handleDownload = async () => {
        const objectURL = `${config.backend_domain}:${config.backend_port}/translations/export?ActiveCustomerID=${activeCustomer}`;
        let exportDataSuccessful = await download(objectURL);
        tableRef.current && tableRef.current.onQueryChange();
        if (!exportDataSuccessful) {
            return snackActions.snackBarComponent(translations['download_error_msg'] || `Could not download file `, 'error');
        }
    }

    const tableActions = [
        rowData => ({
            tooltip: translations["edit_translation"] || "Edit translation",
            icon: EditOutlined,
            onClick: (evt, rowData) => goToEditTranslations(rowData)
        }),
        rowData => ({
            tooltip: translations["delete_translation"] || "Delete translation",
            icon: DeleteOutline,
            onClick: (evt, rowData) => handleDelete(evt, rowData)
        })
    ]

    const goToCreateTranslations = () => {
        createHistory();
        setRedirectOptions({ ...redirectOptions, redirect: true, TranslationsID: null, redirectPath: `/admin/translate/create` });
    };
    const goToUploadTranslations = () => {
        createHistory();
        setRedirectOptions({ ...redirectOptions, redirect: true, TranslationsID: null, redirectPath: `/admin/translate/upload` });
    };
    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'translation_list') ?
                <TranslateList goToUploadTranslations={goToUploadTranslations} goToCreateTranslations={goToCreateTranslations} handleDownload={handleDownload} deleteModalState={deleteModalState}
                    handleDelete={handleDelete} tableColumns={tableColumns} tableActions={tableActions}
                    tableRef={tableRef}
                />
                : null}

        </div >
    );
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
    };
};

const mapDispatchToProps = dispatch => {
    return {
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(Translations));